import React from 'react';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';
import classNames from 'classnames';
import GoogleIcon from './google-icon';

const GoogleButton = ({ onClick, label }) => (
  <button
    type="button"
    className={classNames('ws-google-button', { 'ws-google-button--mobile': bowser.mobile })}
    onClick={onClick}
  >
    <GoogleIcon />
    <span>{label}</span>
  </button>
);

GoogleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default GoogleButton;
